import type { NotificationArgsProps } from "antd";

import { useEffect } from "react";

import { useNotificationsContext } from "../contexts/NotificationsContext";

export type NotificationType = "success" | "info" | "warning" | "error";

interface NotificationParams {
  description: string;
  key?: string;
  message: string;
  options?: Omit<NotificationArgsProps, "title" | "description">;
  type: NotificationType;
}

interface Notifications extends Partial<NotificationParams> {
  shouldTrigger?: boolean;
}

export const useCustomNotification = ({
  key = "",
  shouldTrigger = false,
  type,
  message,
  description,
  options,
}: Notifications = {}) => {
  const { showNotifications } = useNotificationsContext();

  const showNotification = ({
    key,
    type,
    message,
    description,
    options,
  }: NotificationParams) => {
    showNotifications[type]({
      ...(key ? { key } : {}),
      title: message,
      description,
      ...options,
    });
  };

  useEffect(() => {
    if (shouldTrigger && type && message && description) {
      showNotification({
        ...(key ? { key } : {}),
        type,
        message,
        description,
        options,
      });
    }
    // oxlint-disable-next-line react/exhaustive-deps
  }, [shouldTrigger]);

  return { showNotification };
};
